import { render, staticRenderFns } from "./TissueInfo.vue?vue&type=template&id=d549b194&scoped=true"
import script from "./TissueInfo.vue?vue&type=script&lang=js"
export * from "./TissueInfo.vue?vue&type=script&lang=js"
import style0 from "./TissueInfo.vue?vue&type=style&index=0&id=d549b194&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d549b194",
  null
  
)

export default component.exports